import SectionHeading from '@/components/base/SectionHeading';
import ScrollReveal from '@/components/base/ScrollReveal';
import { riskLearningStages } from '@/mocks/riskManagementPage';

const cardTone = [
  'border-background-200 bg-background-50',
  'border-primary-200 bg-primary-50/70',
  'border-background-200 bg-background-50',
  'border-accent-200 bg-accent-50/60',
];

const numTone = [
  'border-primary-500 bg-primary-500 text-background-50',
  'border-primary-300 bg-background-50 text-primary-700',
  'border-background-300 bg-background-50 text-foreground-700',
  'border-accent-300 bg-background-50 text-accent-800',
];

export default function LearningPath() {
  return (
    <section
      id="learning-path"
      className="scroll-mt-[7.5rem] border-b border-background-200 bg-background-100/70 md:scroll-mt-[9rem]"
    >
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between md:gap-12">
          <SectionHeading
            eyebrow="เส้นทางการเรียนรู้"
            title="ขั้นตอนพื้นฐานในการบริหารความเสี่ยง"
            subtitle="เรียงสี่ขั้นตอนตามลำดับที่ใช้ได้จริง เริ่มจากรู้ว่าเสี่ยงได้เท่าไร แล้วแปลงเป็นขนาดสถานะก่อนเปิดออเดอร์ทุกครั้ง"
          />
          <p className="max-w-xs shrink-0 text-xs leading-relaxed text-foreground-600 md:pb-2">
            แต่ละขั้นมีบทความในคลังด้านล่างให้เปิดอ่านต่อทันที ไม่ต้องสมัครสมาชิก
          </p>
        </div>

        <div className="mt-10 md:mt-14">
          <div aria-hidden="true" className="hidden h-px w-full bg-background-300 lg:block" />
          <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5 lg:-mt-px">
            {riskLearningStages.map((stage, index) => (
              <ScrollReveal
                as="li"
                key={stage.no}
                delay={index * 80}
                className="relative flex flex-col self-stretch"
              >
                <div className="hidden items-center gap-2 lg:flex">
                  <span
                    className={`relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border font-num text-xs font-semibold ${numTone[index]}`}
                  >
                    {stage.no}
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-wide text-foreground-500">
                    ขั้นที่ {index + 1}
                  </span>
                </div>

                <div className={`mt-4 flex flex-1 flex-col rounded-xl border p-5 md:p-6 ${cardTone[index]}`}>
                  <div className="flex items-center gap-2 lg:hidden">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-full border font-num text-[11px] font-semibold ${numTone[index]}`}>
                      {stage.no}
                    </span>
                    <span className="text-[11px] font-semibold uppercase tracking-wide text-foreground-500">
                      ขั้นที่ {index + 1}
                    </span>
                  </div>

                  <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg lg:mt-4">
                    {stage.title}
                  </h3>
                  <p className="mt-2.5 text-[13px] leading-relaxed text-foreground-700">{stage.summary}</p>

                  <ul className="mt-4 flex flex-col gap-2 border-t border-background-200/80 pt-4">
                    {stage.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700">
                        <i className="ri-check-line mt-0.5 text-sm text-primary-600" aria-hidden="true" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-auto pt-4">
                    <a
                      href={stage.target}
                      className="inline-flex cursor-pointer items-center gap-1.5 text-xs font-semibold text-primary-700 transition-colors hover:text-primary-800"
                    >
                      {stage.linkLabel}
                      <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}